export enum SettingsEntitySubtype {
  MergedZone = 'MergedZone',
}
